export let defaultTextStyle = {
    fontFamily: 'Sono',
    margin: 0,
    lineHeight: '25px',
    fontSize: '16px'
}